module.exports = __webpack_public_path__ + "img/reply.fd169604.svg";